import React from 'react'
import Slider from 'react-slick';
import carouselSettings from './carouselSettings';
import {RUTA_IMAGEN} from '../../utils/rutasFijas';
import {Link} from 'react-router-dom';
import { traerTarjetasDisponibles } from '../../utils/Tools';

const BancosSlider = () => {

  let settings = carouselSettings[0];
  let tarjetas = traerTarjetasDisponibles();// props.tarjetas;
  if (!tarjetas) {
      tarjetas = [];
  }

    //settings.infinite = true;
   /* if (settings.slidesToShow >= tarjetas.length && tarjetas.length !== 0 ) {
        //settings.infinite = false;
        settings.slidesToShow = tarjetas.length;
    }*/
     settings.infinite = true;
    if (settings.slidesToShow >= tarjetas.length)
          settings.infinite = false;

  return (
        <section className="bancos row">

            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 miraCuotas">Medios de Pago: </div>
            <div className="carousel-bancos col-xl-8 col-lg-8 col-md-8 col-sm-0 col-0">
             <Slider {...settings}  >
              {tarjetas.map((tarjeta) => {
                 return  <div key={tarjeta.id} className="banco" title={tarjeta.legals}>
                          <img src={RUTA_IMAGEN + 'bancos/' + tarjeta.issuer.id + '.png'} width={tarjeta.width} alt={tarjeta.issuer.name} />
                          {tarjeta.max_installments !== 0 ? <p>{tarjeta.max_installments}</p> : null }
                          {/*tarjeta.max_installments !== 0 ? <p>Hasta {tarjeta.max_installments} cuotas</p> : null */}
                        </div>
               })
              }
            </Slider>

            </div>
            {/*FC: con MP
              <a href="https://www.mercadopago.com.ar/cuotas" target="_blank" rel="noopener noreferrer">Ver promociones</a>
              */}
            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 verPromociones">
              <Link to="/formas-de-pago">Ver promociones</Link>
            </div>


      </section>
  )
}

export default BancosSlider



// WEBPACK FOOTER //
// ./src/components/Home/BancosSlider.js